export const watchBorderPanelOverflow = (panelContent, scrollable, onChange = () => {}) => {
    if (!panelContent || !scrollable) {
        return () => {};
    }

    const updateOverflowState = () => {
        onChange(scrollable.scrollHeight > scrollable.clientHeight + 1);
    };

    const resizeObserver = typeof ResizeObserver === 'function'
        ? new ResizeObserver(updateOverflowState)
        : null;
    const mutationObserver = typeof MutationObserver === 'function'
        ? new MutationObserver(updateOverflowState)
        : null;

    resizeObserver?.observe(panelContent);
    resizeObserver?.observe(scrollable);
    mutationObserver?.observe(scrollable, {
        childList: true,
        subtree: true,
        characterData: true,
    });

    scrollable.addEventListener('load', updateOverflowState, true);
    window.addEventListener('resize', updateOverflowState);
    updateOverflowState();

    return () => {
        resizeObserver?.disconnect();
        mutationObserver?.disconnect();
        scrollable.removeEventListener('load', updateOverflowState, true);
        window.removeEventListener('resize', updateOverflowState);
    };
};